import { render, staticRenderFns } from "./recipe-spice-tab.vue?vue&type=template&id=06a1b636&"
import script from "./recipe-spice-tab.vue?vue&type=script&lang=js&"
export * from "./recipe-spice-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports